<template>
  <footer class="tw-mt-12 tw-border-t tw-border-gray-800 tw-pt-10 tw-pb-8 tw-px-4 md:tw-px-8 tw-text-gray-400 tw-w-full" style="background-color: #0f172a;">
    <div class="tw-max-w-7xl tw-mx-auto tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-5 tw-gap-8">
      
      <!-- Brand Column -->
      <div class="tw-flex tw-flex-col tw-gap-4 lg:tw-col-span-2">
        <img 
          src="@/assets/logo-aula.png" 
          alt="Promolíder Logo" 
          class="tw-h-12 tw-w-auto tw-object-contain tw-self-start" 
        />
        <p class="tw-text-sm tw-leading-relaxed">
          Únete a esta maravillosa oportunidad y conoce personas extraordinarias.
        </p>
        <p class="tw-text-sm tw-leading-relaxed">
          Los miembros de nuestra red disfrutan de entrenamientos, capacitación acelerada y apoyo especializado. En Promolíder la consigna es: "Juntos lograremos monetizar tus conocimientos y experiencia".
        </p>
      </div>

      <!-- Contact Column -->
      <div class="tw-flex tw-flex-col tw-gap-4">
        <h3 class="tw-text-lg tw-font-bold tw-text-white tw-font-outfit">Contáctanos</h3>
        <a href="mailto:información@promolider.org" class="tw-flex tw-items-center tw-gap-2 tw-text-sm hover:tw-text-[var(--primary-color)] tw-transition-colors">
          <svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
          información@promolider.org
        </a>
      </div>

      <!-- Links Column -->
      <div class="tw-flex tw-flex-col tw-gap-4">
        <h3 class="tw-text-lg tw-font-bold tw-text-white tw-font-outfit">Enlaces útiles</h3>
        <ul class="tw-flex tw-flex-col tw-gap-2 tw-text-sm">
          <li>
            <router-link to="/courses" class="hover:tw-text-[var(--primary-color)] tw-transition-colors">Catálogo de Cursos</router-link>
          </li>
          <li>
            <a href="https://promolider.org/" target="_blank" class="hover:tw-text-[var(--primary-color)] tw-transition-colors">Sobre nosotros</a>
          </li>
          <li>
            <router-link to="/preguntas-frecuentes" class="hover:tw-text-[var(--primary-color)] tw-transition-colors">Preguntas Frecuentes</router-link>
          </li>
        </ul>
      </div>

      <!-- Social Column -->
      <div class="tw-flex tw-flex-col tw-gap-4">
        <h3 class="tw-text-lg tw-font-bold tw-text-white tw-font-outfit">Síguenos</h3>
        <div class="tw-flex tw-flex-wrap tw-gap-3">
          <a href="https://www.facebook.com/Promolider-101670701715747/" target="_blank" aria-label="Facebook" class="tw-w-10 tw-h-10 tw-rounded-full tw-bg-gray-800 tw-flex tw-items-center tw-justify-center hover:tw-bg-[var(--primary-color)] hover:tw-text-white tw-transition-all tw-text-lg">
            <i class="bi bi-facebook"></i>
          </a>
          <a href="https://www.instagram.com/promoliderorg/" target="_blank" aria-label="Instagram" class="tw-w-10 tw-h-10 tw-rounded-full tw-bg-gray-800 tw-flex tw-items-center tw-justify-center hover:tw-bg-[var(--primary-color)] hover:tw-text-white tw-transition-all tw-text-lg">
            <i class="bi bi-instagram"></i>
          </a>
          <a href="https://www.linkedin.com/company/promol%C3%ADder/" target="_blank" aria-label="LinkedIn" class="tw-w-10 tw-h-10 tw-rounded-full tw-bg-gray-800 tw-flex tw-items-center tw-justify-center hover:tw-bg-[var(--primary-color)] hover:tw-text-white tw-transition-all tw-text-lg">
            <i class="bi bi-linkedin"></i>
          </a>
          <a href="https://www.youtube.com/channel/UCj-NmJXOnJt55aDRh1R0LLg" target="_blank" aria-label="YouTube" class="tw-w-10 tw-h-10 tw-rounded-full tw-bg-gray-800 tw-flex tw-items-center tw-justify-center hover:tw-bg-[var(--primary-color)] hover:tw-text-white tw-transition-all tw-text-lg">
            <i class="bi bi-youtube"></i>
          </a>
          <a href="https://www.tiktok.com/@promolider" target="_blank" aria-label="TikTok" class="tw-w-10 tw-h-10 tw-rounded-full tw-bg-gray-800 tw-flex tw-items-center tw-justify-center hover:tw-bg-[var(--primary-color)] hover:tw-text-white tw-transition-all tw-text-lg">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
              <path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z"/>
            </svg>
          </a>
        </div>
      </div>

    </div>

    <!-- Copyright -->
    <div class="tw-max-w-7xl tw-mx-auto tw-mt-10 tw-pt-6 tw-border-t tw-border-gray-800 tw-text-center tw-text-sm">
      <p>© {{ new Date().getFullYear() }} Promolíder. Todos los derechos reservados.</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterV"
}
</script>
